<template>
  <div>
    <el-form :model="userdata"
             ref="modify"
             label-position="left"
             :inline="formInline"
             :rules="addressRules"
    >

      <el-form-item label="所在地区" label-width="90px"  prop="provinceValue">

        <el-select v-model="provinceValue" placeholder="请选择省" filterable clearable>
          <el-option
              v-for="item in regionData"
              :key="item.value"
              :label="item.label"
              :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" label-width="0px">

        <el-select v-model="cityValue" placeholder="请选择市" filterable clearable>
          <el-option
              v-for="item in countyAndData"
              :key="item.value"
              :label="item.label"
              :value="item">
          </el-option>
        </el-select>

      </el-form-item>
      <el-form-item label="">
        <el-select v-model="areaValue" placeholder="请选择区、县" filterable clearable>
          <el-option
              v-for="item in provinceAndData"
              :key="item.value"
              :label="item.label"
              :value="item">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

  </div>

</template>

<script>
import {mixins} from '@/mixins'

export default {
  mixins: [mixins],
  props: {
    userdata: {
      type: Object,
      default: {}
    },
  },
  name: "AreaSelect",
  data() {
    return {
      countyAndData: [],
      provinceAndData: [],
      provinceValue: '',
      cityValue: '',
      areaValue: '',
      formInline: true,
      addressRules: {
        provinceValue: [
          {required: true, message: '请选择活动区域', trigger: 'blur'}
        ],
      },
    }
  },
  computed: {},
  watch: {
    provinceValue(newVal) {
      if (!newVal) {
        this.countyAndData = [];
        this.cityValue = ''
        return
      }
      this.countyAndData = newVal.children;
      this.cityValue = ''
    },
    immediate: true,
    cityValue(newVal) {
      if (!newVal) {
        this.provinceAndData = [];
        this.areaValue = ''
        return
      }
      this.provinceAndData = newVal.children;
      this.areaValue = ''
    },
    areaValue(newVal) {
      if (newVal) {
        this.$emit('editArea', this.provinceValue.label, this.cityValue.label, newVal.label)
      }
    }
  },
  created() {

  }
}
</script>

<style scoped>

</style>
